module.exports = __webpack_public_path__ + "img/hr-express-splitter-east.ae5b1f20.png";